export function isMobile(): boolean {
	if (typeof window !== 'undefined') {
		// Note that using window.innerWidth will return double the value of the width on some iOS versions
		return document.documentElement.clientWidth < 992;
	}
	return false
}
